import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "stat-cell" }
const _hoisted_3 = { class: "stat-value" }
const _hoisted_4 = { class: "stars" }
const _hoisted_5 = { class: "stat-caption" }
const _hoisted_6 = { class: "stat-cell" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-sub" }
const _hoisted_9 = { class: "stat-caption" }
const _hoisted_10 = { class: "stat-cell" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "stat-sub" }
const _hoisted_13 = { class: "stat-cell" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "stat-label" }
const _hoisted_16 = { class: "stat-caption" }

import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsRow',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, {
      class: "stats-row",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(appData).stats[0].value), 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createVNode(_component_van_icon, {
                    key: i,
                    name: "star",
                    size: "7",
                    color: "#9ca3af"
                  })
                }), 64))
              ]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('donwload.review')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "1" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "divider" }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(appData).stats[1].value), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('appStore.statsYears')), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('appStore.statsAgeRating')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "1" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "divider" }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(appData).stats[2].value), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('download.casino')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "1" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "divider" }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: _unref(appData).stats[3].avatar,
                alt: "",
                class: "dev-avatar"
              }, null, 8, _hoisted_14),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('donwload.appName')), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('appStore.statsDeveloper')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})